import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["innerHTML"]

import GrTooltip from "./GrTooltip.vue";

import infoIcon from "../../assets/img/info-icon.svg";

type InformationTooltipProps = {
  infoText: string | null;
  tooltipIcon?: string;
  altText?: string;
  size?: null | string;
  formTooltip?: boolean;
  disabled?: boolean;
  tooltipWidth?: "large" | "medium" | "small";
};


export default /*@__PURE__*/_defineComponent({
  __name: 'InformationTooltip',
  props: {
    infoText: { default: "" },
    tooltipIcon: { default: infoIcon },
    altText: { default: "Info icon" },
    size: { default: null },
    formTooltip: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    tooltipWidth: { default: "large" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GrTooltip, {
    width: __props.tooltipWidth,
    hideBox: __props.infoText === null
  }, {
    content: _withCtx(() => [
      _createElementVNode("p", {
        class: "text-small",
        innerHTML: __props.infoText
      }, null, 8, _hoisted_2)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "icon", {}, () => [
        (__props.formTooltip)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["tooltip-icon fw-bolder text-tiny", __props.disabled ? '' : 'cursor-pointer'])
            }, " i ", 2))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: __props.tooltipIcon,
              alt: __props.altText,
              class: _normalizeClass([`${__props.size}-icon`, __props.disabled ? '' : 'cursor-pointer'])
            }, null, 10, _hoisted_1))
      ])
    ]),
    _: 3
  }, 8, ["width", "hideBox"]))
}
}

})